export const CHECKLIST = "checklist";
export const QUALITY_CHECK = "qualityCheck";

